module.exports = __webpack_public_path__ + "static/media/IMG_8081.7ab90f52.JPG";